/* eslint-disable import/prefer-default-export */
import icon from '../assets/csifavicon.png';

export const csiConfig = {
  title: 'Canadian Scientific',
  catalog: 'partner',
  partner: 'csi',
  origin: 'https://canadianscientific.ca/',
  host: 'seating.csi.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/csi-logo-bright.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/csi-logo.png',
  buildAChair: 'csi',
  businessInfo: '7777 Eastview Rd, Guelph, ON N1H 6J1',
  headerTheme: '#000000',
  secondaryTheme: '#FFFFFF',
  footerTheme: '#000000',
  headerTextColor: '#FFFFFF',
  footerTextColor: '#FFFFFF',
  buttonTextColor: '#000000',
  footerLogoStyle: {
    maxHeight: '102px',
    maxWidth: '483px',
    paddingTop: '32px',
  },
  phone: '(226) 780-4793',
  email: 'info@canadianscientific.ca',
  bannerColor: '#a8872f',
  extraAttributes: {
    trackId: 'G-KR09W9YPZ1',
    icon,
    colorOverride: {
      buttonColor: '#000000',
      buttonColorDark: '#FFFFFF',
      buttonTextDark: '#000000',
      buttonText: '#FFFFFF',
      titleLight: '#333333',
      titleDark: '#a8872f',
    },
  },
};
